import { render, staticRenderFns } from "./error.vue?vue&type=template&id=10f0aa39&scoped=true&"
import script from "./error.vue?vue&type=script&lang=ts&"
export * from "./error.vue?vue&type=script&lang=ts&"
import style0 from "./error.vue?vue&type=style&index=0&id=10f0aa39&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f0aa39",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NoNetwork: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/NoNetwork/index.vue').default})
